import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * SAMPLE COPY — draft quotes written in the buyer's own language (VOC) to
 * show the angle each review should cover. Replace every quote with a real,
 * verifiable buyer review before launch (FTC + Meta ad review).
 */
const t = (i: number, quote: string): Testimonial => ({
  quote,
  author: coaches[i].name,
  role: coaches[i].role,
  avatar: coaches[i].avatar,
})

export const shortTestimonials: Testimonial[] = [
  t(0, '[Sample] I used to plan practice in the parking lot. Now I open the Season Map, print two pages and walk onto the field knowing exactly what we’re doing.'),
  t(1, '[Sample] I never played lacrosse. The primer and the two-sentence cards got me through week one without feeling lost in front of the parents.'),
  t(2, '[Sample] Pods of three changed our practices. No more lines, no more kids picking grass. They actually ask for Cradle Tag.'),
]

export const moreTestimonials: Testimonial[] = [
  t(3, '[Sample] Half my team stabbed at every catch. I looked it up in the Practice Finder, ran that practice and finally had a plan for it.'),
  t(4, '[Sample] One coach, eighteen kids. The 1-coach version on every plan is the reason I bought it.'),
  t(5, '[Sample] Boys’ and girls’ rule notes on the same page. I stopped looking things up every week and just checked my league rulebook once.'),
]
